import axios from 'axios'

export const OPEN_HP = 'OPEN_HP';
export function openHP() {
  return ({
    type: OPEN_HP
  })
}

export const UPDATE_FILL_VALUE = 'UPDATE_FILL_VALUE';
export function updateFillValue(value) {
  return ({
    type: UPDATE_FILL_VALUE,
    value: value
  })
}

export const UPDATE_FILL_ANSWER = 'UPDATE_FILL_ANSWER';
export function updateFillAnswer(answer) {
  return ({
    type: UPDATE_FILL_ANSWER,
    answer: answer
  })
}

export const SORT_FILL_VALUE = 'SORT_FILL_VALUE';
export function sortFillValue() {
  return ({
    type: SORT_FILL_VALUE
  })
}

export const SKIP_GAP = 'SKIP_GAP';
export function skipGap() {
  return ({
    type: SKIP_GAP
  })
}

export const GET_GAP_UPDATE = 'GET_GAP_UPDATE';
export function getGapUpdate(body) {
  return ({
    type: GET_GAP_UPDATE,
    body: body
  })
}

export const DESTROY_VIEW = 'DESTROY_VIEW';
export function destroyView() {
  return ({
    type: DESTROY_VIEW
  })
}

export const RESET_FILL = 'RESET_FILL';
export function resetFill(answer) {
  return ({
    type: RESET_FILL,
    answer: answer
  })
}

export const REMOVE_GAP_FOR_EDIT = 'REMOVE_GAP_FOR_EDIT';
export function removeGapForEdit(filteredAnswers) {
  return ({
    type: REMOVE_GAP_FOR_EDIT,
    filteredAnswers: filteredAnswers
  })
}

export const SAVE_ANSWER = 'SAVE_ANSWER';
export function saveAnswer() {
  return ({
    type: SAVE_ANSWER
  })
}

export const SET_WEIGHT_DATA = 'SET_WEIGHT_DATA';
export function setWeightData(data) {
  return ({
    type: SET_WEIGHT_DATA,
    data: data
  })
}

export function getGaps() {
  return function(dispatch) {
    return axios({
      method: 'get',
      url: '/api/bc/member/xmp/gap/',
      withCredentials: true,
      headers: {
        Accept: "application/json, text/javascript, */*; q=0.01",
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then((response) => {
        return response.data;
      })
      .then((body) => {
        dispatch(getGapUpdate(body))
        return body
      })
  }
}

export const SET_GAP_UPDATE = 'SET_GAP_UPDATE';
export function setGapUpdate(body, answeredQuestion) {
  return ({
    type: SET_GAP_UPDATE,
    body: body,
    answeredQuestion: answeredQuestion
  })
}

export const ON_LOAD = 'ON_LOAD';
export function onLoad(stowed) {
  return ({
    type: ON_LOAD,
    stowed: stowed
  })
}

export function setGap(gap_id, answeredQuestion) {
  return function(dispatch) {
    return axios({
      method: 'get',
      url: '/api/bc/xmp/gaps/'+gap_id,
      withCredentials: true,
      headers: {
        Accept: 'application/json, text/javascript, */*; q=0.01',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then((response) => {
        return response.data;
      })
      .then((body) => {
        dispatch(setGapUpdate(body, answeredQuestion))
        return body
      })
      .catch((error) => {
        // console.log(error);
      })
  }
}

export function matchesExhausted(requestBody) {
  return function(dispatch) {
    return axios({
      method: 'post',
      url: '/api/bc/member/xmp/fills',
      withCredentials: true,
      headers: {
        Accept: 'application/json, text/javascript, */*; q=0.01',
        'content-type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: JSON.stringify(requestBody)
    })
      .then((res) => {
        console.log(res)
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function xmpSave(gapID) {
  return function(dispatch) {
    return axios({
      method: 'put',
      url: '/api/counter/xmp/'+gapID+'/save',
      withCredentials: true,
      headers: {
        Accept: '*/*',
        'content-type': 'application/json; charset=utf-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .catch((error) => {
        // console.log(error)
      })
  }
}

export function postFill(requestBody) {
  return function(dispatch) {
    return axios({
      method: 'post',
      url: '/api/bc/member/xmp/fills',
      withCredentials: true,
      headers: {
        Accept: 'application/json, text/javascript, */*; q=0.01',
        'content-type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: JSON.stringify(requestBody)
    })
  }
}

export function gapLoad(gapID) {
  return function(dispatch) {
    return axios({
      method: 'put',
      url: '/api/counter/xmp/'+gapID+'/load',
      withCredentials: true,
      headers: {
        Accept: '*/*',
        'content-type': 'application/json; charset=utf-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
  }
}
// export function logoutAction(loginData) {
//   return function(dispatch) {
//     localStorage.removeItem('jwt');
//     setAuthorizationToken(false);
//     dispatch(userLoggedOut());
//   }
// }
//
// export function loginAction(loginData) {
//   return function(dispatch) {
//     return axios.post('/users/login', loginData)
//       .then(function(response) {
//         const token = response.data.token;
//         localStorage.setItem('jwt', token);
//         setAuthorizationToken(token);
//         var decoded = jwtdecode(token);
//         dispatch(userLoggedIn(decoded));
//         return true;
//       })
//   }
// }
//
// export function setAuthorizationToken(token) {
//   if(token) {
//     axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
//   }
//   else {
//     delete axios.defaults.headers.common['Authorization'];
//   }
// }
//
//



// WEBPACK FOOTER //
// ./src/actions/index.js